import React from 'react';
import { useSxStyles    } from "../styles/sxStyles";
import { getCaseLabel, getCitationLabel } from "./lookupFunctions";
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import NameListItem from "./NameListItem";
import Grid2 from "@mui/material/Grid2";

const NameList = (props) => {
    const nameData = props.nameData;
    const court = props.court;
    const selectNameBalance = props.selectNameBalance;
    const classes = useSxStyles;

    return (<>
        <Typography variant='h6' color='primary' sx={{fontSize: '1.2rem', marginTop: '.5rem', marginBottom: '.5rem'}}>
            Choose a Balance
        </Typography>
        <Typography variant='subtitle1' sx={{marginTop: '0', marginBottom: '1rem', lineHeight: '1.4rem'}}>
            Your search returned results that might include balances for multiple people, and CitePay can only process payments for a single
            person per payment. Please select one of the entries below to look up all the balances for that party.
        </Typography>
        <Paper elevation={3} sx={{...classes.listContainer, maxHeight: '70vh', overflow: 'auto'}}>
            <List sx={classes.list} >
                <ListItem alignItems='flex-start' sx={classes.listPadding}>
                    <ListItemText
                        sx={classes.listText}
                        primary={
                            <Grid2
                                container
                                spacing={1}
                                alignItems="top"
                                sx={{width: '100%'}}
                            >
                                <Grid2
                                    size={{
                                        xs: 3,
                                        lg: 2
                                    }}>&nbsp;</Grid2>
                                <Grid2
                                    size={{
                                        xs: 5,
                                        lg: 2
                                    }}>Party Name</Grid2>
                                <Grid2
                                    size={{
                                        xs: 4,
                                        lg: 2
                                    }}>DOB</Grid2>
                                <Grid2
                                    size={{
                                        xs: 4,
                                        lg: 2
                                    }}>{getCaseLabel(court)}</Grid2>
                                <Grid2
                                    size={{
                                        xs: 4,
                                        lg: 2
                                    }}>{getCitationLabel(court)}</Grid2>
                                <Grid2
                                    sx={{textAlign: 'right'}}
                                    size={{
                                        xs: 4,
                                        lg: 2
                                    }}>Amount</Grid2>
                            </Grid2>
                        }
                    />
                </ListItem>
                {nameData.map((bal, idx) => {
                    return (
                        <>
                            <NameListItem balance={bal} court={court} selectNameBalance={selectNameBalance} />
                            { idx < (nameData.length - 1) &&
                                <Divider sx={classes.listDivider}/>
                            }
                        </>
                    );
                })}
            </List>
        </Paper>
    </>);
}

export default NameList;
